import Session from '@/handler/session'
import WidgetServices from '@/components/inc/widget/services'
import Error from '@/handler/error'

export default {
  data: () => {
    return {
      widgetsMeta: [],
      widgetsOrdered: [],
      hiddenWidgets: [],
      widgetOrderMap: {},
      widgetColsMap: {},
      widgetHeightMap: {},
      visibilityLoaded: false,
      editingLocked: false
    }
  },
  methods: {
    initDashboardWidgets() {
      this.prepareWidgetsMeta()
      this.fetchWidgetConfig()
      this.fetchWidgetVisibility()
    },
    fetchWidgetConfig() {
      WidgetServices.obtenerWidgetConfig(this.configWidget.module_id, this.configWidget.profile_id)
        .then((response) => {
          const data = response.data
          this.editingLocked = !!(data && data.locked)
        })
        .catch((error) => {
          this.editingLocked = false
          this.$awn.alert(Error.showError(error))
        })
    },
    setEditingLocked(value) {
      const locked = !!value
      this.editingLocked = locked
      const payload = {
        module_id: this.configWidget.module_id,
        profile_id: this.configWidget.profile_id,
        locked: locked
      }
      WidgetServices.guardarWidgetConfig(payload)
        .catch((error) => {
          this.editingLocked = !locked
          this.$awn.alert(Error.showError(error))
        })
    },
    prepareWidgetsMeta() {
      const permissions = Session.getSession().auth ? Session.getSession().auth.user.permissions.widget : []
      const filterFn = typeof this.filterWidgetsMeta === 'function'
        ? this.filterWidgetsMeta.bind(this)
        : null

      this.widgetsMeta = permissions
        .filter(widget =>
          widget.module_id === this.configWidget.module_id &&
          widget.profile_id === this.configWidget.profile_id
        )
        .map((widget) => {
          return {
            id: widget.id,
            reference: widget.reference,
            title: widget.title ? widget.title : widget.reference,
            description: widget.description ? widget.description : '',
            cols: widget.cols,
            order: widget.order,
            hasAccess: true,
            php_id: widget.php_id,
            external_url: widget.external_url,
            height: widget.height
          }
        })
        .filter(widget => {
          if(filterFn) {
            return !!filterFn(widget)
          }
          return true
        })
        .sort((a, b) => {
          const orderA = a.order
          const orderB = b.order
          if(orderA !== undefined && orderA !== null && orderB !== undefined && orderB !== null) {
            return orderA - orderB
          }
          if(orderA !== undefined && orderA !== null) {
            return -1
          }
          if(orderB !== undefined && orderB !== null) {
            return 1
          }
          return (a.id || 0) - (b.id || 0)
        })
    },
    fetchWidgetVisibility() {
      this.visibilityLoaded = false

      WidgetServices.obtenerWidgetVisibility(this.configWidget.module_id, this.configWidget.profile_id)
        .then((response) => {
          const data = response.data
          if(Array.isArray(data)) {
            this.hiddenWidgets = data
              .filter(item => item.visible === false || item.visible === 0)
              .map(item => item.reference)
            this.widgetOrderMap = {}
            this.widgetColsMap = {}
            this.widgetHeightMap = {}
            data.forEach(item => {
              if(item.order !== null && item.order !== undefined) {
                this.widgetOrderMap[item.reference] = item.order
              }
              if(item.cols !== null && item.cols !== undefined) {
                this.widgetColsMap[item.reference] = item.cols
              }
              if(item.height !== null && item.height !== undefined) {
                this.widgetHeightMap[item.reference] = item.height
              }
            })
          } else {
            this.hiddenWidgets = []
            this.widgetOrderMap = {}
            this.widgetColsMap = {}
            this.widgetHeightMap = {}
          }
          this.applyWidgetVisibility()
          this.visibilityLoaded = true
        })
        .catch((error) => {
          this.hiddenWidgets = []
          this.widgetOrderMap = {}
          this.widgetColsMap = {}
          this.widgetHeightMap = {}
          this.applyWidgetVisibility()
          this.visibilityLoaded = true
          this.$awn.alert(Error.showError(error))
        })
    },
    saveHiddenWidgetsRemote(reference, visible) {
      const payload = {
        module_id: this.configWidget.module_id,
        profile_id: this.configWidget.profile_id,
        reference: reference,
        visible: visible
      }
      return WidgetServices.guardarWidgetVisibility(payload)
    },
    saveHiddenWidgetsRemoteBulk() {
      const payload = {
        module_id: this.configWidget.module_id,
        profile_id: this.configWidget.profile_id,
        hidden: this.hiddenWidgets
      }
      return WidgetServices.guardarWidgetVisibilityBulk(payload)
    },
    setWidgetVisibility(reference, visible) {
      if(this.editingLocked) {
        return
      }
      const before = this.hiddenWidgets.slice()
      const index = this.hiddenWidgets.indexOf(reference)
      if(visible && index !== -1) {
        this.hiddenWidgets.splice(index, 1)
      }
      if(!visible && index === -1) {
        this.hiddenWidgets.push(reference)
      }
      this.applyWidgetVisibility()
      this.saveHiddenWidgetsRemote(reference, visible)
        .catch((error) => {
          this.hiddenWidgets = before
          this.applyWidgetVisibility()
          this.$awn.alert(Error.showError(error))
        })
    },
    onToggleWidget({ reference, visible }) {
      this.setWidgetVisibility(reference, visible)
    },
    hideWidget(reference) {
      this.setWidgetVisibility(reference, false)
    },
    resetWidgetsVisibility() {
      if(this.editingLocked) {
        return
      }
      const snapshot = {
        hidden: this.hiddenWidgets.slice(),
        orderMap: Object.assign({}, this.widgetOrderMap),
        colsMap: Object.assign({}, this.widgetColsMap),
        heightMap: Object.assign({}, this.widgetHeightMap)
      }
      this.hiddenWidgets = []
      this.widgetOrderMap = {}
      this.widgetColsMap = {}
      this.widgetHeightMap = {}
      this.applyWidgetVisibility()
      this.resetWidgetsDefaults()
        .catch((error) => {
          this.hiddenWidgets = snapshot.hidden
          this.widgetOrderMap = snapshot.orderMap
          this.widgetColsMap = snapshot.colsMap
          this.widgetHeightMap = snapshot.heightMap
          this.applyWidgetVisibility()
          this.$awn.alert(Error.showError(error))
        })
    },
    resetWidgetsDefaults() {
      const payload = {
        module_id: this.configWidget.module_id,
        profile_id: this.configWidget.profile_id
      }
      return WidgetServices.resetWidgetVisibility(payload)
        .then(() => this.fetchWidgetVisibility())
    },
    applyWidgetVisibility() {
      const orderMap = this.widgetOrderMap || {}
      const colsMap = this.widgetColsMap || {}
      const heightMap = this.widgetHeightMap || {}
      const base = this.widgetsMeta.map((item, index) => {
        const overrideCols = colsMap[item.reference]
        const cols = overrideCols !== undefined && overrideCols !== null ? overrideCols : item.cols
        const overrideHeight = heightMap[item.reference]
        const height = overrideHeight !== undefined && overrideHeight !== null ? overrideHeight : item.height
        return Object.assign({}, item, { _index: index, cols: cols, height: height })
      })

      base.sort((a, b) => {
        const orderA = orderMap[a.reference]
        const orderB = orderMap[b.reference]

        if(orderA !== undefined && orderA !== null && orderB !== undefined && orderB !== null) {
          return orderA - orderB
        }
        if(orderA !== undefined && orderA !== null) {
          return -1
        }
        if(orderB !== undefined && orderB !== null) {
          return 1
        }
        return a._index - b._index
      })

      this.widgetsOrdered = base.filter(item => this.hiddenWidgets.indexOf(item.reference) === -1)
    },
    saveWidgetOrder() {
      if(this.editingLocked) {
        return
      }
      const order = this.widgetsOrdered.map(item => item.reference)
      this.widgetOrderMap = {}
      order.forEach((reference, index) => {
        this.widgetOrderMap[reference] = index
      })

      const payload = {
        module_id: this.configWidget.module_id,
        profile_id: this.configWidget.profile_id,
        order: order
      }
      WidgetServices.guardarWidgetVisibilityOrder(payload)
        .catch((error) => {
          this.$awn.alert(Error.showError(error))
        })
    },
    resizeWidget(reference) {
      const current = this.getWidgetCols(reference)
      const sizes = this.getWidgetColsOptions(reference, current)
      if(!sizes.length) {
        return
      }
      const index = sizes.indexOf(current)
      const next = sizes[(index + 1) % sizes.length]
      this.setWidgetCols(reference, next)
    },
    previewWidgetCols({ reference, cols }) {
      if(this.editingLocked) {
        return
      }
      if(reference === undefined || cols === undefined) {
        return
      }
      this.widgetColsMap[reference] = cols
      this.applyWidgetVisibility()
    },
    commitWidgetCols({ reference, cols }) {
      if(this.editingLocked) {
        return
      }
      if(reference === undefined || cols === undefined) {
        return
      }
      this.setWidgetCols(reference, cols)
    },
    previewWidgetHeight({ reference, height }) {
      if(this.editingLocked) {
        return
      }
      if(reference === undefined || height === undefined) {
        return
      }
      this.widgetHeightMap[reference] = height
      this.applyWidgetVisibility()
    },
    commitWidgetHeight({ reference, height }) {
      if(this.editingLocked) {
        return
      }
      if(reference === undefined || height === undefined) {
        return
      }
      this.setWidgetHeight(reference, height)
    },
    previewWidgetSize({ reference, cols, height }) {
      if(this.editingLocked) {
        return
      }
      if(cols !== undefined) {
        this.previewWidgetCols({ reference, cols })
      }
      if(height !== undefined) {
        this.previewWidgetHeight({ reference, height })
      }
    },
    commitWidgetSize({ reference, cols, height }) {
      if(this.editingLocked) {
        return
      }
      if(cols !== undefined) {
        this.commitWidgetCols({ reference, cols })
      }
      if(height !== undefined) {
        this.commitWidgetHeight({ reference, height })
      }
    },
    setWidgetCols(reference, cols) {
      const prev = this.widgetColsMap[reference]
      this.widgetColsMap[reference] = cols
      this.applyWidgetVisibility()

      const payload = {
        module_id: this.configWidget.module_id,
        profile_id: this.configWidget.profile_id,
        reference: reference,
        cols: cols
      }
      WidgetServices.guardarWidgetVisibility(payload)
        .catch((error) => {
          if(prev === undefined) {
            delete this.widgetColsMap[reference]
          } else {
            this.widgetColsMap[reference] = prev
          }
          this.applyWidgetVisibility()
          this.$awn.alert(Error.showError(error))
        })
    },
    setWidgetHeight(reference, height) {
      const prev = this.widgetHeightMap[reference]
      this.widgetHeightMap[reference] = height
      this.applyWidgetVisibility()

      const payload = {
        module_id: this.configWidget.module_id,
        profile_id: this.configWidget.profile_id,
        reference: reference,
        height: height
      }
      WidgetServices.guardarWidgetVisibility(payload)
        .catch((error) => {
          if(prev === undefined) {
            delete this.widgetHeightMap[reference]
          } else {
            this.widgetHeightMap[reference] = prev
          }
          this.applyWidgetVisibility()
          this.$awn.alert(Error.showError(error))
        })
    },
    getWidgetCols(reference) {
      const override = this.widgetColsMap[reference]
      if(override !== undefined && override !== null) {
        return override
      }
      const base = this.widgetsMeta.find(item => item.reference === reference)
      const baseCols = base && base.cols ? parseInt(base.cols, 10) : null
      return baseCols || 4
    },
    getWidgetHeight(reference) {
      const override = this.widgetHeightMap[reference]
      if(override !== undefined && override !== null) {
        return override
      }
      return null
    },
    getWidgetColsOptions(reference, current) {
      const options = [3, 4, 6, 8, 12]
      if(current && options.indexOf(current) === -1) {
        options.unshift(current)
      }
      return options
    }
  }
}
